import makeValidationSchema from './AddiInfoMakeValidationSchema'
import { components, useTranslation } from 'cng-web-lib'
import React from 'react'
import Namespace from '../../../../constants/locale/Namespace'
import SbciInvoiceKeys from '../../../../constants/locale/key/SbciInvoice'
import { Grid } from '@material-ui/core'
import { useFormContext } from 'react-hook-form'

const {
  form: {
    field: { CngCodeMasterAutocompleteField, CngTextField },
  },
  CngGridItem,
} = components

const DEFAULT_INITIAL_VALUES = Object.freeze({
  additionalInfoType: "",
  additionalInfoNo: "",
})

const FORMIK_PROPS = {
  initialValues: { ...DEFAULT_INITIAL_VALUES },
  makeValidationSchema: makeValidationSchema
}

function Fields({
  index,
  disabled,
  showNotification,
  parentIdDropdownItems,
  shouldHideMap
}) {
  const { translate } = useTranslation(Namespace.SBCI_INVOICE)
  const translatedTextsObject = makeTranslatedTextsObject()

  const { setValue } = useFormContext()

  function makeTranslatedTextsObject() {
    let additionalInfoType = translate(
      Namespace.SBCI_INVOICE,
      SbciInvoiceKeys.LineitemAddiInfo.ADDITIONAL_INFO_TYPE
    )
    let additionalInfoNo = translate(
      Namespace.SBCI_INVOICE,
      SbciInvoiceKeys.LineitemAddiInfo.ADDITIONAL_INFO_NO
    )

    return { additionalInfoType, additionalInfoNo }
  }

	return (
    <Grid container spacing={1}>
      <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap?.additionalInfoType}>
        <CngCodeMasterAutocompleteField
          codeType='SBCI_ADDITIONAL_INFO_TYPE'
          name={typeof index === 'number' ? `lineitemAddiInfo.${index}.additionalInfoType` : 'additionalInfoType'}
          label={translatedTextsObject.additionalInfoType}
          disabled={disabled}
          onChange={(_, option) => setValue(typeof index === 'number' ? `lineitemAddiInfo.${index}.additionalInfoType` : 'additionalInfoType', option ? option.value : '', {shouldValidate:true})}
          required
          size='small'
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap?.additionalInfoNo}>
        <CngTextField
          name={typeof index === 'number' ? `lineitemAddiInfo.${index}.additionalInfoNo` : 'additionalInfoNo'}
          label={translatedTextsObject.additionalInfoNo}
          disabled={disabled}
          onChange={(event) => setValue(typeof index === 'number' ? `lineitemAddiInfo.${index}.additionalInfoNo` : 'additionalInfoNo', event.target.value.toUpperCase(), {shouldValidate:true})}
          required
          size='small'
        />
      </CngGridItem>
    </Grid>
	)
}

const LineitemAddiInfoFormProperties = Object.freeze({
  formikProps: FORMIK_PROPS,
  Fields: Fields
})

export default LineitemAddiInfoFormProperties
